import { type Descendant, Text } from 'slate'

import deserializeRichText from './deserializeRichText'
import type { SerializedRichText } from './types'

export default function getMentionedUserIds(value: SerializedRichText): number[] {
  if (value.serialization_method !== 'slate_json_v1') {
    return []
  }

  const allElements = deserializeRichText(value)
  const userIds: number[] = []

  const getNestedUserMentions = (elements: Descendant[]) => {
    elements.forEach(element => {
      if (Text.isText(element)) {
        return
      }
      if (element.type === 'mention') {
        userIds.push(element.userId)
      }
      getNestedUserMentions(element.children)
    })
  }

  getNestedUserMentions(allElements)
  return userIds
}
